var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationMedia.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationMedia.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"ProductionDesignInitiativeApplicationMedia ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoCode")) {
t_5 += "ProductionDesignInitiativeApplicationMedia--hasMedia";
;
}
t_5 += "\">\n        <div class=\"ProductionDesignInitiativeApplicationMedia-caption\">Video YouTube/Vimeo URL:</div>\n        <input type=\"text\" name=\"videoUrl\" class=\"ProductionDesignInitiativeApplicationMedia-input\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoUrl")) {
t_5 += " value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoUrl"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoCode")) {
t_5 += " data-code=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoCode"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoProvider")) {
t_5 += " data-provider=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoProvider"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n        <div class=\"ProductionDesignInitiativeApplicationMedia-preview\">Preview</div>\n        <div class=\"ProductionDesignInitiativeApplicationMedia-embed\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoCode")) {
t_5 += "\n                ";
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"videoCode")), env.opts.autoescape);
t_5 += "\n            ";
;
}
t_5 += "\n        </div>\n        <div class=\"ProductionDesignInitiativeApplicationMedia-delete\">\n            <div class=\"ProductionDesignInitiativeApplicationMedia-deleteItem\"></div>\n            <div class=\"ProductionDesignInitiativeApplicationMedia-deleteItem\"></div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("ProductionDesignInitiativeApplicationMedia");
context.setVariable("ProductionDesignInitiativeApplicationMedia", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationMedia.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationMedia.jinja
// module id = 59
// module chunks = 0